import { MONTHS, currentMonth } from "@/lib/site";

export const SeasonCalendar = ({ months = [], testid = "season-calendar" }) => {
  const now = currentMonth();
  return (
    <div className="grid grid-cols-6 sm:grid-cols-12 gap-1.5" data-testid={testid}>
      {MONTHS.map((m, i) => {
        const on = months.includes(i + 1);
        return (
          <div
            key={m}
            data-testid={`${testid}-month-${i + 1}`}
            data-available={on}
            className={`relative rounded-md py-3 text-center text-xs font-semibold ${
              on ? "bg-emerald-500 text-white" : "bg-stone-200 text-stone-500"
            } ${now === i + 1 ? "ring-2 ring-offset-2 ring-amber-600" : ""}`}
          >
            {m}
          </div>
        );
      })}
    </div>
  );
};

export const SeasonBadge = ({ status, testid }) => (
  <span
    data-testid={testid}
    className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wider ${
      status.available ? "bg-emerald-100 text-emerald-900" : "bg-stone-200 text-stone-700"
    }`}
  >
    <span className={`h-1.5 w-1.5 rounded-full ${status.available ? "bg-emerald-500" : "bg-stone-500"}`} />
    {status.label}
  </span>
);
